export default "__VITE_ASSET__CDE5DkQj__"